/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordresetemailinstructions3Inputs */

const en_passwordresetemailinstructions3 = /** @type {(inputs: Passwordresetemailinstructions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click the link in the email to reset your password. If you don't see the email, check your spam folder.`)
};

const de_passwordresetemailinstructions3 = /** @type {(inputs: Passwordresetemailinstructions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipp auf den Link in der E-Mail, um dein Passwort zurückzusetzen. Keine E-Mail da? Schau in deinen Spam-Ordner.`)
};

/**
* | output |
* | --- |
* | "Click the link in the email to reset your password. If you don't see the email, check your spam folder." |
*
* @param {Passwordresetemailinstructions3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordresetemailinstructions3 = /** @type {((inputs?: Passwordresetemailinstructions3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordresetemailinstructions3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordresetemailinstructions3(inputs)
	return de_passwordresetemailinstructions3(inputs)
});
export { passwordresetemailinstructions3 as "passwordResetEmailInstructions" }